import { minitop } from './minitop';
import { apertureCesar } from './aperture-cesar';
import { linkedinCampaigns } from './linkedin-campaigns';
import { tlp } from './tlp';
import { appInstall } from './app-install';

export { AGG } from './types';

export const TEMPLATES = [
  minitop,
  apertureCesar,
  linkedinCampaigns,
  tlp,
  appInstall,
];

export const getTemplate = (id) => TEMPLATES.find((t) => t.id === id);

export const getTemplatesForClient = (clientId) =>
  TEMPLATES.filter((t) => !t.client_ids || t.client_ids.includes(clientId));

export { minitop, apertureCesar, linkedinCampaigns, tlp, appInstall };
